let _hasDOMMeasurements: boolean | null = null;

const hasDOMMeasurements = () => {
    if (_hasDOMMeasurements === null) {
        if (typeof window === 'undefined' || !document?.body) {
            return false;
        }

        const el = document.createElement('div');
        el.style.position = 'absolute';
        el.style.visibility = 'hidden';
        el.style.height = '10px';
        document.body.appendChild(el);

        const height = el.offsetHeight;
        document.body.removeChild(el);

        _hasDOMMeasurements = height > 0;
    }

    return _hasDOMMeasurements;
};

export default hasDOMMeasurements;
